const { produce } = require("immer");
const {
  writeIndex,
  updateElements,
  deleteElements,
  updateAllElements,
  deleteAllElements,
  requestFailed,
  retrySuccess,
  retryInvalid,
  subReducers,
  streamProgress,
  clearStreamProgress
} = require("./methods");

function initIndex(index) {
  return Object.keys(index).reduce((acc, k) => {
    acc[k] = {};
    return acc;
  }, {});
}

var reducers = {};

module.exports = function (state = {}, action) {
  switch (action.type) {
    case "ADD_WORKSPACE":
      return produce(state, draft => {
        let projectUid = action.uid;
        Object.keys(action.index).forEach(licenceUid => {
          if (!(projectUid in draft)) draft[projectUid] = {};
          let ws = draft[projectUid];
          if (!(licenceUid in ws)) ws[licenceUid] = {};
          let wsApp = ws[licenceUid];
          if (projectUid + licenceUid in reducers) {
            const reducer = reducers[projectUid + licenceUid]
            if (!wsApp.data && reducer.data) wsApp.data = reducer.data(state[projectUid][licenceUid].data, action, state);
            if (!wsApp.local && reducer.local) wsApp.local = reducers[projectUid + licenceUid].local(state[projectUid][licenceUid].local, action, state);
            if (!wsApp.shared && reducer.shared) wsApp.shared = reducers[projectUid + licenceUid].shared(state[projectUid][licenceUid].shared, action, state);
            // if(!wsApp.setting && reducer.setting) wsApp.setting = reducers[projectUid+licenceUid].setting(state[projectUid][licenceUid].setting, action, state);
          }
          let init = initIndex(action.index[licenceUid].index)
          if (!wsApp.index) wsApp.index = init;
          if (!wsApp.shared) wsApp.shared = action.index[licenceUid].shared
          // if(!wsApp.setting) wsApp.setting = action.index[licenceUid].setting
          if (!wsApp.failed) wsApp.failed = []
          wsApp.init = action.index[licenceUid].index;
          if (!wsApp.streamProgress) wsApp.streamProgress = {}
        });
      });
    case "LOAD_BUNDLE":
      return produce(state, draft => {
        let {
          licenceUid,
          projectUid,
          dataReducer,
          localReducer,
          sharedReducer,
          // settingReducer
        } = action;
        if (!reducers[projectUid + licenceUid] && (dataReducer || localReducer || sharedReducer /* || settingReducer*/)) {
          reducers[projectUid + licenceUid] = {}
        }
        if (dataReducer) reducers[projectUid + licenceUid].data = dataReducer
        if (localReducer) reducers[projectUid + licenceUid].local = localReducer
        if (sharedReducer) reducers[projectUid + licenceUid].shared = sharedReducer
        // if(settingReducer) reducers[projectUid+licenceUid].setting = settingReducer
        if (!(projectUid in draft)) draft[projectUid] = {};
        let ws = draft[projectUid];
        if (!(licenceUid in ws)) ws[licenceUid] = {}
        let wsApp = ws[licenceUid];
        if (!wsApp.failed) wsApp.failed = []
        if (dataReducer && !wsApp.data) wsApp.data = dataReducer(undefined, action, state);
        if (localReducer && !wsApp.local) {
          wsApp.local = localReducer(undefined, action, state);
          if (wsApp.local.selectors && !wsApp.local.selectors.project) wsApp.local.selectors.project = projectUid
        }
        if (sharedReducer && !wsApp.shared) wsApp.shared = sharedReducer(undefined, action, state);
        // if(settingReducer && !wsApp.setting) wsApp.setting = settingReducer(undefined, action, state);
      });

    case "WORKSPACE_WRITE_INDEX":
      return writeIndex(state, action);
    case "WORKSPACE_UPDATE_ELEMENTS":
      return updateElements(state, action);
    case "WORKSPACE_DELETE_ELEMENTS":
      return deleteElements(state, action);
    case "WORKSPACE_UPDATE_ALL_ELEMENTS":
      return updateAllElements(state, action);
    case "WORKSPACE_DELETE_ALL_ELEMENTS":
      return deleteAllElements(state, action);
    case "WORKSPACE_REQUEST_FAILED":
      return requestFailed(state, action)
    case "WORKSPACE_RETRY_SUCCESS":
      return retrySuccess(state, action)
    case "WORKSPACE_RETRY_INVALID":
      return retryInvalid(state, action)
    case "WORKSPACE_STREAM_PROGRESS":
      return streamProgress(state, action)
    case "WORKSPACE_CLEAR_STREAM":
      return clearStreamProgress(state, action)
    default:
      const { projectUid, licenceUid } = action;
      if (projectUid + licenceUid in reducers) {
        if (action.type === "WORKSPACE_UPDATED") {
          return subReducers(produce(state, draft => {
            if (action.projectUid in draft) {
              draft[action.projectUid].users = action.users
            }
          }), action, reducers[projectUid + licenceUid])
        }
        return subReducers(state, action, reducers[projectUid + licenceUid])
      } else {
        if (action.type === "WORKSPACE_UPDATED") {
          return produce(state, draft => {
            if (action.projectUid in draft) {
              draft[action.projectUid].users = action.users
            }
          })
        }
        return state
      }
  }
}